import { Toaster } from "react-hot-toast";

export const NotificationProvider = ({ children }) => {
  return (
    <>
      <Toaster
        toastOptions={{
          className: "",
          style: {
            fontSize: "17px",
          },
        }}
      />
      {children}
    </>
  )
}
